import { Container } from "react-bootstrap";
import "react-calendar/dist/Calendar.css";
import { useParams } from "react-router-dom";
import { ConvertDate } from "../../components/ConvertDate";
import "./actualityDetails.css";

const ActualityDetails = ({ actus }) => {
	let { id } = useParams();
	const actu = actus.find((item) => item.id === +id);

	return (
		<Container className="containerActuDetails">
			<p className="titreActuDetail">{actu.titre}</p>
			<p className="dateActuDetail">{ConvertDate(actu.date)}</p>
			<div className="containerActuDetail">
				<div className="imgActuDetail col-lg-5 col-sm-12">
					<img src={actu.image} alt="actualité" />
				</div>
				<div className=" textActuDetail col-lg-7 col-sm-12">
					<p className="minDescriptionActuDetail preline">
						{actu.mini_description}
					</p>
					<p className="descriptionActuDetail preline">{actu.text}</p>
					{actu.lien && (
						<div className="linkActuDetail">
							<a
								href={actu.lien}
								target="_blank"
								rel="noreferrer"
								alt="site pour en savoir plus sur l'actualité"
							>
								En savoir +
							</a>
						</div>
					)}
				</div>
			</div>
		</Container>
	);
};

export default ActualityDetails;
